import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
  Navigate,
  useParams,
  useNavigate,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./styles/App.css";
import { isEmpty } from "./functions/isEmpty";
import useFetch from "./functions/useFetch";

import Home from "./screens/Home";
import * as authentication from "./functions/authentication";
import useScreenType from "./functions/useScreenType";
import { LanguageProvider } from "./contexts/LanguageContext";
import Product from "./screens/Product";
import Seller from "./screens/SellerHome";
import Create from "./screens/Create";
import SellerHome from "./screens/SellerHome";
import SellerProfile from "./screens/SellerProfile";
import Payout from "./screens/Payout";
import Checkout from "./screens/Checkout";
import professions from "./texts/Professions";
import Orders from "./screens/Orders";
import Order from "./screens/Order";
import Login from "./screens/Login";
import Menu from "./screens/Menu";
import BecomeSeller from "./screens/BecomeSeller";
import Bottombar from "./components/Bottombar";
import DesktopSidebar from "./components/DesktopSidebar";

const developerMode = true;

export default function App() {
  let apiURL = "https://cloud.letsfluence.com";
  if (developerMode) {
    apiURL = "https://developercloud.letsfluence.com";
  }

  /* Auth Token */
  const [authToken, setAuthToken] = useState("");

  /* userdata */
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [shadowUserData, setShadowUserData] = useState([]);
  const [isSeller, setIsSeller] = useState(false);

  /* orderdata */
  const [order, setOrder] = useState({});
  const [reloadOrders, setReloadOrders] = useState(0);
  const [reloadPayouts, setReloadPayouts] = useState(false);
  const [activeOrderRedirect, setActiveOrderRedirect] = useState(false);
  const [becomeSellerActive, setBecomeSellerActive] = useState(false);

  /* user specific Data */
  const [filteredBusiness, setFilteredBusiness] = useState("");
  const [filteredServices, setFilteredServices] = useState([]);
  const [searchInput, setSearchInput] = useState("");

  const [scrollPositionHome, setScrollPositionHome] = useState(0);
  const [scrollPositionSeller, setScrollPositionSeller] = useState(0);

  const [reload, setReload] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isMuted, setIsMuted] = useState(true); // State to keep track of whether the video is muted
  const isMobile = useScreenType();
  const [uploadQueue, setUploadQueue] = useState([]);

  const destroySession = () => {
    try {
      localStorage.removeItem("@jwtmentora");
      setAuthToken();
      setCompanyData([]);
      setBecomeSellerActive(false);
      setReload(!reload);
    } catch (e) {
      // saving error
    }
  };

  const getData = () => {
    try {
      const jsonValue = localStorage.getItem("@jwtmentora");
      var resJSON = jsonValue.substring(1, jsonValue.length - 1);
      setAuthToken({ JWT: resJSON });
    } catch (e) {
      // error reading value
    }
  };

  if (isEmpty(authToken) && localStorage.getItem("@jwtmentora")) {
    getData();
  }

  const signIn = async () => {
    let helpobject = {};

    const setJWT = (data) => {
      helpobject = data;
    };

    const storeData = (value) => {
      try {
        localStorage.setItem("@jwtmentora", JSON.stringify(value));
        console.log(value);
      } catch (e) {
        // saving error
      }
    };
    const res = await fetch(`${apiURL}/api/authenticate`, {
      method: "POST",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify({
        email: email,
        password: password,
      }),
    });

    // check if response exists
    if (res.status >= 0 && res.status <= 299) {
      const jwt = await res.text();
      // check if response has jwt
      if (jwt.length > 50) {
        setJWT(jwt);
        storeData(helpobject);
        console.log("localstorage erfolgreich");
        setAuthToken(setAuthToken({ JWT: helpobject }));
        console.log("StoreData ist Da. Redirect!");
      } else {
        alert("Login fehlgeschlagen");
      }
      setIsUploading(false);
    } else {
      // @Todo: Handle errors
      console.log(res.status, res.statusText);
      setIsUploading(false);
    }
  };

  const signUp = async () => {
    let helpobject = {};

    const setJWT = (data) => {
      helpobject = data;
      console.log(helpobject);
    };
    const storeData = (value) => {
      try {
        localStorage.setItem("@jwtmentora", JSON.stringify(value));
        console.log(value);
      } catch (e) {
        // saving error
      }
    };

    const res = await fetch(`${apiURL}/api/signup.php`, {
      method: "POST",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify({
        email: email,
        password: password,
        username: username,
      }),
    });

    // check if response exists
    if (res.status >= 0 && res.status <= 299) {
      const jwt = await res.text();
      // check if response has jwt
      if (jwt.length > 50) {
        setJWT(jwt);
        storeData(helpobject);
        console.log("localstorage erfolgreich");
        setAuthToken(setAuthToken({ JWT: helpobject }));
        console.log("StoreData ist Da. Redirect!");
      } else {
        alert("Registrierung fehlgeschlagen");
      }
      setIsUploading(false);
    } else {
      // @Todo: Handle errors
      console.log(res.status, res.statusText);
      setIsUploading(false);
    }
  };

  const {
    data: userData,
    loading: loadingUser,
    error: errorUser,
  } = useFetch(
    `${apiURL}/api/users/`,
    authToken,
    "GET",
    null,
    [authToken] // Additional dependencies, if needed
  );

  const {
    data: companyData,
    loading: loadingCompanyData,
    error: errorCompanyData,
    setData: setCompanyData,
  } = useFetch(
    `${apiURL}/api/companies/?id=` + userData.companyID,
    authToken,
    "GET",
    null,
    [userData, authToken, reload] // Additional dependencies, if needed
  );

  const {
    data: creators,
    loading: loadingCreatorData,
    error: errorCreatorData,
  } = useFetch(
    `${apiURL}/api/creators/noAuthOnlyGET.php`,
    authToken,
    "GET",
    null,
    [reload] // Additional dependencies, if needed
  );

  const {
    data: services,
    loading: loadingServices,
    error: errorServices,
  } = useFetch(
    `${apiURL}/api/services/index.php`,
    authToken,
    "GET",
    null,
    [reload] // Additional dependencies, if needed
  );

  const {
    data: templates,
    loading: loadingTemplates,
    error: errorTemplates,
  } = useFetch(
    `${apiURL}/api/templates/index.php`,
    authToken,
    "GET",
    null,
    [reload] // Additional dependencies, if needed
  );

  const {
    data: orders,
    loading: loadingOrders,
    error: errorOrders,
  } = useFetch(
    `${apiURL}/api/orders/index.php`,
    authToken,
    "GET",
    null,
    [reload, reloadOrders] // Additional dependencies, if needed
  );

  const {
    data: payouts,
    loading: loadingPayouts,
    error: errorPayouts,
  } = useFetch(
    `${apiURL}/api/payouts/index.php`,
    authToken,
    "GET",
    null,
    [reload, reloadPayouts] // Additional dependencies, if needed
  );

  useEffect(() => {
    if (!isEmpty(orders) && !isEmpty(companyData)) {
      // orderData aussortieren alle videos die buyer_id != companyData[0].id
      let newArr = filterByBuyerId(orders, companyData);
      // übrig geblieben durchgehen am key fulfillment_overlayvideourl. alle die nicht leer sind behalten, rest rauswerfen
      addItemsToQueue(newArr);
    }
    // zurueckgegebener wert soll const updateService fulfillment_overlay updaten
    // gleichzeitig soll mergefile.php aufgerufen werden
    // zurueckgegebener wert soll const updateService fulfillment_mergefile updaten
  }, [orders, companyData]);

  function filterByBuyerId(array, companyData) {
    return array.filter((item) => item.buyer_id == companyData[0].id);
  }

  const addItemsToQueue = (array) => {
    array.forEach((item) => {
      if (isEmpty(item.fulfillment_overlayvideourl)) {
        stayOverlayCreationProcess(item);
        setUploadQueue((prevQueue) => {
          // Check if the item already exists in the queue
          const exists = prevQueue.some((queueItem) => queueItem === item);
          if (!exists) {
            return [...prevQueue, item];
          }
          return prevQueue;
        });
      }
    });
  };

  const objectExistsInQueue = (object, queue) => {
    return queue.some(
      (queueItem) => JSON.stringify(queueItem) === JSON.stringify(object)
    );
  };

  const stayOverlayCreationProcess = async (order) => {
    // call overlaycreation.php
    if (objectExistsInQueue(order, uploadQueue)) {
      return;
    }

    let destinationURL = "";
    if (order.service_template_schema_id == 1) {
      const resa = await fetch(`${apiURL}/api/images/createoverlayvideo.php`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authToken?.JWT}`,
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: JSON.stringify({
          videourl: order.service_video_url,
          companyname: order.input_companyname,
          companywebsite: order.input_companywebsite,
          imgurl: order.input_pic,
          colorBackground: order.input_companycolor,
        }),
      });

      await resa.text().then((value) => createMergeFile(value, order));
    } else if (order.service_template_schema_id == 2) {
      const resa = await fetch(`${apiURL}/api/images/createoverlayexpose.php`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authToken?.JWT}`,
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: JSON.stringify({
          videourl: order.service_video_url,
          companyname: order.input_companyname,
          companywebsite: order.input_companywebsite,
          companyphone: order.input_companyphone,
          imgurl: order.input_pic,
          colorBackground: order.input_companycolor,
          exposeTitle: order.input_exposeTitle,
          exposeDescription: order.input_exposeDescription,
        }),
      });

      await resa.text().then((value) => createMergeFile(value, order));
    }
  };

  const createMergeFile = async (overlayvideourl, order) => {
    console.log("overlay finished");
    const resa = await fetch(`${apiURL}/api/images/mergeVideos.php`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken?.JWT}`,
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: JSON.stringify({
        urls: [order.service_video_url, overlayvideourl],
      }),
    });

    await resa
      .text()
      .then((value) => updateMergefileInDB(value, overlayvideourl, order));
  };

  const updateMergefileInDB = async (value, overlayvideourl, order) => {
    const resa = await fetch(`${apiURL}/api/orders/index.php?id=` + order.id, {
      method: "POST",
      headers: {
        //   Authorization: `Bearer ${authToken?.JWT}`,
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: JSON.stringify({
        fulfillment_mergedfile_url: value,
        fulfillment_overlayvideourl: overlayvideourl,
      }),
    });

    await resa.text().then((value) => uploadEnds(value));
  };

  const uploadEnds = (value) => {
    console.log(value);
  };

  const fetchNewOrderData = () => {
    let now = Math.floor(Date.now() / 1000);
    if (window.location.pathname != "/checkout") {
      setReloadOrders(now);
    }
  };

  useEffect(() => {
    // Set up the interval to run the function every 10 seconds
    const intervalId = setInterval(fetchNewOrderData, 10000);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, []); // Empty dependency array ensures this runs once on mount

  useEffect(() => {
    if (searchInput.length > 2 && !isEmpty(services)) {
      // alle services durchmappen bei searchTags
      let newArr = filterByTag(services, searchInput);
      setFilteredServices(newArr);
    } else {
      setFilteredServices(services);
    }
  }, [searchInput, services]);

  function filterByTag(array, searchString) {
    const lowerCaseSearchString = searchString.toLowerCase(); // Suchstring in Kleinbuchstaben umwandeln
    const resultArray = array.filter((item) => {
      if (item.template_searchTags) {
        // Split den String in einzelne Tags und trimme Leerzeichen
        const tags = item.template_searchTags
          .split(",")
          .map((tag) => tag.trim().toLowerCase());
        // Prüfen, ob eines der Tags den Suchstring enthält
        return tags.some((tag) => tag.includes(lowerCaseSearchString));
      }
      return false;
    });
    return resultArray;
  }

  useEffect(() => {
    if (!isEmpty(companyData)) {
      if (companyData[0].isACreator == 1 && !isSeller) {
        setIsSeller(true);
      }
    }
  }, [companyData]);

  return (
    <div className="app">
      <LanguageProvider>
        <Router>
          {!isEmpty(authToken) && isMobile && (
            <Bottombar
              companyData={companyData}
              setScrollPositionHome={setScrollPositionHome}
              setScrollPositionSeller={setScrollPositionSeller}
              isSeller={isSeller}
              setIsSeller={setIsSeller}
            />
          )}
          {!isMobile && (
            <DesktopSidebar
              companyData={companyData}
              setScrollPositionHome={setScrollPositionHome}
              setScrollPositionSeller={setScrollPositionSeller}
              isSeller={isSeller}
              setIsSeller={setIsSeller}
            />
          )}
          <Routes>
            <Route
              path="/"
              element={
                <Home
                  isMobile={isMobile}
                  apiURL={apiURL}
                  authToken={authToken}
                  creators={creators}
                  companyData={
                    isEmpty(companyData) && !isEmpty(shadowUserData)
                      ? shadowUserData[0]
                      : companyData[0]
                  }
                  categories={professions}
                  services={filteredServices}
                  filteredBusiness={filteredBusiness}
                  setFilteredBusiness={setFilteredBusiness}
                  setSearchInput={setSearchInput}
                  searchInput={searchInput}
                  destroySession={destroySession}
                  scrollPositionHome={scrollPositionHome}
                  setScrollPositionHome={setScrollPositionHome}
                  becomeSellerActive={becomeSellerActive}
                  isSeller={isSeller}
                  setIsSeller={setIsSeller}
                />
              }
            />
            <Route
              path="/orders"
              element={
                <Orders
                  isMobile={isMobile}
                  apiURL={apiURL}
                  authToken={authToken}
                  creators={creators}
                  companyData={
                    isEmpty(companyData) && !isEmpty(shadowUserData)
                      ? shadowUserData[0]
                      : companyData[0]
                  }
                  categories={professions}
                  services={services}
                  filteredBusiness={filteredBusiness}
                  setFilteredBusiness={setFilteredBusiness}
                  setSearchInput={setSearchInput}
                  searchInput={searchInput}
                  orders={orders}
                  isSeller={isSeller}
                  setIsSeller={setIsSeller}
                  payouts={payouts}
                />
              }
            />
            <Route
              path="/orders/:orderid"
              element={
                <Order
                  isMobile={isMobile}
                  apiURL={apiURL}
                  authToken={authToken}
                  creators={creators}
                  companyData={
                    isEmpty(companyData) && !isEmpty(shadowUserData)
                      ? shadowUserData[0]
                      : companyData[0]
                  }
                  categories={professions}
                  services={services}
                  filteredBusiness={filteredBusiness}
                  setFilteredBusiness={setFilteredBusiness}
                  setSearchInput={setSearchInput}
                  searchInput={searchInput}
                  orders={orders}
                  reload={reload}
                  setReload={setReload}
                  payouts={payouts}
                />
              }
            />
            <Route
              path="/product/:productid"
              element={
                <Product
                  isMobile={isMobile}
                  apiURL={apiURL}
                  authToken={authToken}
                  creators={creators}
                  companyData={
                    isEmpty(companyData) && !isEmpty(shadowUserData)
                      ? shadowUserData[0]
                      : companyData[0]
                  }
                  templates={templates}
                  services={services}
                  categories={professions}
                  order={order}
                  setOrder={setOrder}
                />
              }
            />
            <Route
              path="/seller"
              element={
                <SellerHome
                  isMobile={isMobile}
                  apiURL={apiURL}
                  authToken={authToken}
                  creators={creators}
                  companyData={
                    isEmpty(companyData) && !isEmpty(shadowUserData)
                      ? shadowUserData[0]
                      : companyData[0]
                  }
                  templates={templates}
                  services={services}
                  categories={professions}
                  orders={orders}
                  scrollPositionSeller={scrollPositionSeller}
                  setScrollPositionSeller={setScrollPositionSeller}
                  becomeSellerActive={becomeSellerActive}
                  isSeller={isSeller}
                  setIsSeller={setIsSeller}
                  payouts={payouts}
                />
              }
            />
            <Route
              path="/menu"
              element={
                <Menu
                  isMobile={isMobile}
                  apiURL={apiURL}
                  authToken={authToken}
                  creators={creators}
                  companyData={
                    isEmpty(companyData) && !isEmpty(shadowUserData)
                      ? shadowUserData[0]
                      : companyData[0]
                  }
                  templates={templates}
                  services={services}
                  categories={professions}
                  orders={orders}
                  scrollPositionSeller={scrollPositionSeller}
                  setScrollPositionSeller={setScrollPositionSeller}
                  destroySession={destroySession}
                />
              }
            />
            <Route
              path="/sellerprofile"
              element={
                <SellerProfile
                  isMobile={isMobile}
                  apiURL={apiURL}
                  authToken={authToken}
                  creators={creators}
                  companyData={
                    isEmpty(companyData) && !isEmpty(shadowUserData)
                      ? shadowUserData[0]
                      : companyData[0]
                  }
                  templates={templates}
                  services={services}
                  categories={professions}
                  reload={reload}
                  setReload={setReload}
                  becomeSellerActive={becomeSellerActive}
                  setBecomeSellerActive={setBecomeSellerActive}
                />
              }
            />
            <Route
              path="/becomeSeller"
              element={
                <BecomeSeller
                  isMobile={isMobile}
                  apiURL={apiURL}
                  authToken={authToken}
                  creators={creators}
                  companyData={
                    isEmpty(companyData) && !isEmpty(shadowUserData)
                      ? shadowUserData[0]
                      : companyData[0]
                  }
                  templates={templates}
                  services={services}
                  categories={professions}
                  reload={reload}
                  setReload={setReload}
                  becomeSellerActive={becomeSellerActive}
                  setBecomeSellerActive={setBecomeSellerActive}
                />
              }
            />
            <Route
              path="/payout/:orderid"
              element={
                <Payout
                  isMobile={isMobile}
                  apiURL={apiURL}
                  authToken={authToken}
                  creators={creators}
                  companyData={
                    isEmpty(companyData) && !isEmpty(shadowUserData)
                      ? shadowUserData[0]
                      : companyData[0]
                  }
                  templates={templates}
                  services={services}
                  categories={professions}
                  order={order}
                  setOrder={setOrder}
                  payouts={payouts}
                  setReloadPayouts={setReloadPayouts}
                  reloadPayouts={reloadPayouts}
                />
              }
            />
            <Route
              path="/checkout"
              element={
                <Checkout
                  isMobile={isMobile}
                  apiURL={apiURL}
                  authToken={authToken}
                  creators={creators}
                  companyData={
                    isEmpty(companyData) && !isEmpty(shadowUserData)
                      ? shadowUserData[0]
                      : companyData[0]
                  }
                  templates={templates}
                  services={services}
                  categories={professions}
                  order={order}
                  setOrder={setOrder}
                  reload={reload}
                  setReload={setReload}
                  setActiveOrderRedirect={setActiveOrderRedirect}
                />
              }
            />
            <Route
              path="/create/:templateid"
              element={
                <Create
                  isMobile={isMobile}
                  apiURL={apiURL}
                  authToken={authToken}
                  creators={creators}
                  companyData={
                    isEmpty(companyData) && !isEmpty(shadowUserData)
                      ? shadowUserData[0]
                      : companyData[0]
                  }
                  templates={templates}
                  services={services}
                  categories={professions}
                  reload={reload}
                  setReload={setReload}
                  becomeSellerActive={becomeSellerActive}
                  setBecomeSellerActive={setBecomeSellerActive}
                />
              }
            />
            <Route
              path="/login"
              element={
                <Login
                  isMobile={isMobile}
                  authToken={authToken}
                  email={email}
                  setEmail={setEmail}
                  password={password}
                  setPassword={setPassword}
                  signUp={signUp}
                  username={username}
                  setUsername={setUsername}
                  signIn={signIn}
                  setIsUploading={setIsUploading}
                  isUploading={isUploading}
                  companyData={
                    isEmpty(companyData) && !isEmpty(shadowUserData)
                      ? shadowUserData[0]
                      : companyData[0]
                  }
                  activeOrderRedirect={activeOrderRedirect}
                  setActiveOrderRedirect={setActiveOrderRedirect}
                  setBecomeSellerActive={setBecomeSellerActive}
                />
              }
            />
          </Routes>
          <></>
        </Router>
      </LanguageProvider>
    </div>
  );
}
